import { jsx as m } from "react/jsx-runtime";
import { StennLogoWrapper as d } from "./styles24.mjs";
import { useTheme as l } from "@mui/material";
import { STENN_LOGO as n } from "./constants22.mjs";
const S = ({
  testId: i,
  compact: p,
  invertColors: o,
  size: a = "small",
  color: e = "primary",
  ...s
}) => {
  const {
    palette: { mode: t }
  } = l(), r = t === "light" ? "dark" : "light", c = p ? n[o ? r : t][e].compact : n[o ? r : t][e].fullSize;
  return /* @__PURE__ */ m(d, { "data-testid": i, $size: a, ...s, children: /* @__PURE__ */ m(c, {}) });
};
export {
  S as StennLogo
};
//# sourceMappingURL=index43.mjs.map
